// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1cqwmor1 {
  height: 100%;
}
._1cqwmor2 {
  background: #f3f3f3;
  padding: 0 10px;
  font-family: Museo Sans,Arial,sans-serif;
  font-size: 36px;
  font-weight: 400;
}
.recommendations-carousel + .react-multi-carousel-dot-list {
  position: static;
}
@media screen and (min-width: 769px) {
  ._1cqwmor0 {
    padding: 0 10px;
  }
  ._1cqwmor2 {
    font-size: 36px;
  }
}
@media screen and (max-width: 768px) {
  ._1cqwmor0 {
    padding: 0 5px;
  }
  ._1cqwmor2 {
    font-size: 24px;
  }
}
@media screen and (max-width: 480px) {
  .recommendations-carousel + .react-multi-carousel-dot-list > button {
    display: none;
  }
  .recommendations-carousel + .react-multi-carousel-dot-list li div {
    width: 6px;
    height: 6px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,UAAU;IACV,WAAW;EACb;AACF","sourcesContent":["._1cqwmor1 {\n  height: 100%;\n}\n._1cqwmor2 {\n  background: #f3f3f3;\n  padding: 0 10px;\n  font-family: Museo Sans,Arial,sans-serif;\n  font-size: 36px;\n  font-weight: 400;\n}\n.recommendations-carousel + .react-multi-carousel-dot-list {\n  position: static;\n}\n@media screen and (min-width: 769px) {\n  ._1cqwmor0 {\n    padding: 0 10px;\n  }\n  ._1cqwmor2 {\n    font-size: 36px;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._1cqwmor0 {\n    padding: 0 5px;\n  }\n  ._1cqwmor2 {\n    font-size: 24px;\n  }\n}\n@media screen and (max-width: 480px) {\n  .recommendations-carousel + .react-multi-carousel-dot-list > button {\n    display: none;\n  }\n  .recommendations-carousel + .react-multi-carousel-dot-list li div {\n    width: 6px;\n    height: 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
